import React from "react";
import Modal from "react-modal";
import { formatJalali } from "../../routes/challenges/jalaliDate";
import { toFarsiNumber } from "../../custom/helpers";
import "../../styles/Modals.css";
import "../../styles/Achievements.css";

const RARITY_LABELS = {
  common: "معمولی",
  uncommon: "خاص",
  rare: "کمیاب",
  epic: "حماسی",
  legendary: "افسانه‌ای",
};

// Detail sheet for a single badge - opened from AchievementGrid, the
// featured-badges row on Account.js, and UserProfilePreviewModal.
// `achievement` is null when closed so the Modal stays mounted (smoother
// open/close transition) while its content is guarded.
function AchievementModal({ achievement, onClose }) {
  const isOpen = !!achievement;
  const a = achievement || {};
  const earned = !!a.earned;
  const icon = a.icon && a.icon.trim() ? a.icon : "🏆";
  const hasTarget = a.target != null && a.target > 0;
  const progressPct = hasTarget
    ? Math.min(100, Math.round(((a.progress || 0) / a.target) * 100))
    : 0;

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className="modal" overlayClassName="overlay">
      <div className="modal-header">
        <h2>جزئیات دستاورد</h2>
        <a onClick={onClose}>
          <span className="icon-iconclose rectangle-1 heading-1 grey-3"></span>
        </a>
      </div>
      <div className="modal-body centerAlign">
        <div
          className={`achievementModalIcon ${
            earned ? `achRarity-${a.rarity || "common"}` : "achievementCardLocked"
          }`}
        >
          {earned ? icon : "🔒"}
        </div>

        <p className="heading-2 marginTop5">{a.name}</p>
        <p className="caption-1 grey-2 yekan marginTop5">{a.description}</p>

        <div className="spc-between marginTop5">
          <span className="smallTag caption-1 yekan">{RARITY_LABELS[a.rarity] || a.rarity}</span>
          <span className="smallTag caption-1 yekan">{toFarsiNumber(a.points)} امتیاز</span>
        </div>

        {earned ? (
          <p className="caption-1 green-1 yekan marginTop5">
            {a.earned_at ? `به دست آمده در ${formatJalali(a.earned_at, "DD MMMM YYYY")}` : "به دست آمده"}
          </p>
        ) : (
          <>
            <p className="caption-1 grey-2 yekan marginTop5">قفل شده</p>
            {hasTarget && (
              <div className="achievementModalProgressWrap">
                <div className="achievementModalProgressBar">
                  <div className="achievementModalProgressFill" style={{ width: `${progressPct}%` }} />
                </div>
                <p className="caption-2 grey-2 marginTop5">
                  {toFarsiNumber(a.progress || 0)} / {toFarsiNumber(a.target)}
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </Modal>
  );
}

export default AchievementModal;
